var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkarIconsCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ipSCorrect0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f99704",
    fillRule: "evenodd",
    stroke: "#f99704",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "m4 24l5-5l10 10L39 9l5 5l-25 25L4 24Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f99704",
    d: "M0 0h48v48H0z",
    mask: "url(#ipSCorrect0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsCorrect);
export default __webpack_public_path__ + "static/media/akar-icons_correct.733f0e54265666c752e94c86ac0bac3f.svg";
export { ForwardRef as ReactComponent };